module.exports = __webpack_public_path__ + "img/img-2-4.72a0608d.webp";